import React, { PropTypes } from 'react';
import Fiche from './Fiche';

const Topcircle = () => (<div className="top-circle"></div>);
const Toptitle = ({ title }) => (<div className="top-title">{title}</div>);

Toptitle.propTypes = {
  title: PropTypes.string.isRequired,
};

const Actu = ({ items, lang, title }) => (
  <div>
    <Topcircle />
    <Toptitle title={title} />
    <div className="fichecontainer">
      {items.get('data', []).map((item, i) => <Fiche lang={lang} key={i} item={item} />)}
    </div>
    <Topcircle />
  </div>
);

Actu.propTypes = {
  lang: PropTypes.string.isRequired,
  items: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default Actu;



// WEBPACK FOOTER //
// ./common/components/Actu.js